export default __webpack_public_path__ + "static/FeatureJungle-Regular-cdba24d347538ced523410d18350dacf.woff2";